import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { useState } from 'react'

interface QuoteAcceptVersionDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  onAccept: (payload: { customerAcceptedDate: string | null }) => void | Promise<void>
  versionNumber?: number | null
  versionName?: string | null
}

export function QuoteAcceptVersionDialog({
  open,
  onOpenChange,
  onAccept,
  versionNumber,
  versionName,
}: QuoteAcceptVersionDialogProps) {
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [customerAcceptedDate, setCustomerAcceptedDate] = useState<string>(() =>
    new Date().toISOString().split('T')[0]
  )

  const handleConfirm = async () => {
    try {
      setIsSubmitting(true)
      await onAccept({ customerAcceptedDate: customerAcceptedDate || null })
      onOpenChange(false)
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle>Valider la commande</DialogTitle>
        </DialogHeader>

        <div className="space-y-4">
          <p className="text-sm text-muted-foreground">
            Confirmer que le client a donné son accord
            {versionNumber != null ? (
              <>
                {' '}pour la version <span className="font-medium text-foreground">V{versionNumber}</span>
                {versionName?.trim() ? (
                  <span className="font-medium text-foreground"> — “{versionName.trim()}”</span>
                ) : null}
              </>
            ) : null}
            . Cette action marquera le devis comme accepté.
          </p>

          <div className="space-y-1">
            <Label className="text-sm">Date d'acceptation client</Label>
            <Input
              type="date"
              value={customerAcceptedDate}
              max={new Date().toISOString().split('T')[0]}
              onChange={(e) => setCustomerAcceptedDate(e.target.value)}
              disabled={isSubmitting}
            />
          </div>

          <div className="flex justify-end gap-2">
            <Button variant="outline" onClick={() => onOpenChange(false)} disabled={isSubmitting}>
              Annuler
            </Button>
            <Button onClick={handleConfirm} disabled={isSubmitting}>
              {isSubmitting ? 'Validation…' : 'Valider'}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
